import React, { ReactElement, useState } from 'react';
import { Button, Switch } from 'tdesign-react';

import NovaDialog from '@/components/dialog';
import { SceneType } from '@/interface';

interface IProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  type: SceneType;
  isFirst: boolean;
  sceneNum: number;
}

export const FinalSwitch: React.FC<IProps> = (props) => {
  const {
    value = false,
    onChange,
    disabled = false,
    type,
    isFirst,
  } = props;

  const [visible, setVisible] = useState(false);
  const [dialogConfig, setDialogConfig] = useState<{
    message: string,
    buttons: ReactElement | null
  }>({ message: '', buttons: null });

  const close = () => {
    setVisible(false);
  };

  const handleChange = (val: boolean) => {
    if (props.disabled) return;
    if (val === false) {
      onChange(val);
      return;
    }

    if (isFirst) {
      setDialogConfig({
        message: '当前为初始幕，无法设定为结局幕。请前往「故事线」面板，先设置新的初始幕再来操作吧～',
        buttons: (
          <Button theme='primary' onClick={close}>
            我知道了
          </Button>
        ),
      });
      setVisible(true);
    } else if (type === SceneType.SCENE_TYPE_OPTION) {
      setDialogConfig({
        message: '设定为结局幕后，您当前已编辑的「选项内容」将被清空。请确认是否继续？',
        buttons: (
          <>
            <Button theme='default' onClick={close}>
              取消
            </Button>
            <Button
              theme='primary'
              onClick={() => {
                onChange(val);
                close();
              }}
            >
              确认
            </Button>
          </>
        ),
      });
      setVisible(true);
    } else {
      onChange(val);
    }
  };

  return (
    <>
      <Switch
        value={value}
        onChange={handleChange}
        disabled={disabled}
        label={['开', '关']}
      />

      <NovaDialog
        dialogConfig={{
          visible,
          onClose: close,
          confirmBtn: dialogConfig.buttons,
          cancelBtn: null,
          theme: 'warning',
          header: '提示',
          placement: 'center',
        }}
      >
        <div className={'nova-save-tips'}>
          {dialogConfig.message}
        </div>
      </NovaDialog>
    </>
  );
};
